import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=c53803a0&scoped=true&"
import script from "./Audit.vue?vue&type=script&lang=js&"
export * from "./Audit.vue?vue&type=script&lang=js&"
import style0 from "./Audit.vue?vue&type=style&index=0&id=c53803a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53803a0",
  null
  
)

/* custom blocks */
import block0 from "./Audit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports